import { TimeZone } from "client/DateAndTime/timezones";
import { useUserProfileStore } from "client/Features/Settings/UserProfile/userProfileStore";
import { useValueEqualMemo } from "./useValueEqualMemo";

export function useUserTimezone(): TimeZone {
	const userTimeZone: TimeZone = useUserProfileStore(x => x.userTimezone);

	return useValueEqualMemo(
		(): TimeZone => userTimeZone,
		[userTimeZone]
	);
}